import React from 'react';
import * as S from './TopRoutes.styles';
import TopRoutes from './TopRoutes';
import CabHourlyCarouselUI from '../../../../../shared/containers/CabHourlyCarousel/CabHourlyCarouselUI'
import { useSelector } from 'react-redux';
import { staticRentalDetails } from '../../../../../shared/pages/SeoPage/redux/selector';
import { gcTripCategoryScreen } from '../../../../../shared/config/omni';
export interface IToolTip {
    lTitle: string,
    lSubTitle: string,
    toolTipData: string
}
export interface IRoutes {
    title: string,
    subtitle: string,
    includedDistance: string,
    extraFare: string,
    startingPrice: string,
    src_id: string,
    dest_id: string,
    source: string,
    destination: string,
    isLPG: boolean,
    toolTip: IToolTip,
    link: string
} 
export interface ITopRoutes {
    isCarType: boolean,
    routes: Array<IRoutes>,
    onAction: (route) => void,
    title: string,
    subtitle: string,
    tableThirdColHeading?: string;
    showPackageCarousel ?: boolean
    onPackageChange?: () => void
}

export default function(props: ITopRoutes) {
    const staticRentalData  = useSelector(staticRentalDetails)
    const { isCarType = false, routes = [], onAction, title = '', subtitle = '',tableThirdColHeading='', showPackageCarousel = false } = props;
    const parseLPG = (lpg) => {
        const toolTipData = `
            <h5 class="ico12"><b>${lpg?.title}</b></h5>
            <p class="ico12 marginT2">${lpg?.sub_title_html}</p>
            <div class="marginT5">
                <h5 class="ico12"><b>${lpg?.claim_title}</b></h5>
                <ul>
                    ${lpg?.claim_steps_html_list?.map((item, index) => `<li class="ico12 marginT2">${index+1}. ${item}</li>`).join("")}
                </ul>
            </div>
        `;
        return { lTitle: lpg?.srp_car_html_label, lSubTitle: lpg?.srp_car_cta, toolTipData }
    }

    if (routes && routes?.length > 0) {
        return (
            <S.Wrapper>
                {title && <S.Title>{title}</S.Title>}
                {showPackageCarousel ? (
                    <S.HrPackageCard>
                        <CabHourlyCarouselUI data={staticRentalData} itemCount={staticRentalData?.length} onPackageChange={props?.onPackageChange} is_static={staticRentalData[0]?.is_static} invokedFor={gcTripCategoryScreen}/>
                    </S.HrPackageCard>
                ) : null}
                <S.Table>
                    <S.Header>
                        <S.TableRow>
                            <S.RouteColumn>{subtitle}</S.RouteColumn>
                            <S.FareColumn>Included kms & Extra fare</S.FareColumn>
                            <S.PriceColumnHeading>{tableThirdColHeading || 'Cab Price'}</S.PriceColumnHeading>
                            {/* <S.CTAColumn></S.CTAColumn> */}
                        </S.TableRow>
                    </S.Header>
                    <S.BodyWrapper>
                        {routes?.map((route, index) => {
                            return (
                                <TopRoutes
                                    key={`${title}-${index}`}
                                    route={route}
                                    isCarType={isCarType}
                                    onAction={(route) => onAction(route)}
                                    toolTipData={route?.isLPG ? parseLPG(route?.toolTip) : {}}
                                />
                            );
                        })}
                    </S.BodyWrapper>
                </S.Table>
            </S.Wrapper>
        )
    }
    return null;
}